import React from 'react';
import { useTranslation } from 'react-i18next';

import LinearProgress from './linear-progress';

export default function PaymentProgressOverlay({
  isOpen,
}: {
  isOpen: boolean;
}): React.JSX.Element | null {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="payment-progress"
      role="dialog"
      aria-modal="true"
      aria-label={t('basket.contactingComgate')}
    >
      <LinearProgress />
      <p>{t('basket.contactingComgate')}</p>
    </div>
  );
}
